import { createFileRoute, lazyRouteComponent, notFound, redirect } from '@tanstack/react-router';
import * as z from 'zod';
import { validateParams } from '@/router/utils';
import { isInferenceAvailable } from '@/utils/cluster-utils';

export const Route = createFileRoute(
  '/_authenticated/_dashboard/accounts/$accountId/clusters/$clusterId/_tabs/inference/$inferenceModelId',
)({
  params: validateParams(
    z.object({
      inferenceModelId: z.guid(),
    }),
  ),
  // `inferenceModels` comes from the parent `inference` route, which resolved them (and refused hybrid clusters).
  beforeLoad: ({ context: { inferenceModels }, params: { accountId, clusterId, inferenceModelId } }) => {
    if (!isInferenceAvailable(inferenceModels)) {
      throw redirect({
        to: '/accounts/$accountId/clusters/$clusterId/inference',
        params: { accountId, clusterId },
        replace: true,
      });
    }

    const inferenceModel = inferenceModels.find((model) => model.id === inferenceModelId);
    if (!inferenceModel) {
      throw notFound();
    }
  },
  component: lazyRouteComponent(() => import('./$inferenceModelId.component'), 'ClusterInferenceModelComponent'),
});
